import { IAllLang } from '../../types/lang'
import { enumAllLang } from './enum'
import { sideMenuAllLang } from './sideMenu'
import { offerAllLang } from './offer'
import { offerScopeAllLang } from './offerScope'
import { offerSpendAllLang } from './offerSpend'
import { generalAllLang } from './general'
import { loginAllLang } from './login'
import { postbackSendAllLang } from './postbackSend'
import { revenueAgencyAllLang } from './revenueAgency'
import { revenueSpendAllLang } from './revenueSpend'
import { accountAllLang } from './account'
import { roleAllLang } from './role'
import { affiliateAllLang } from './affiliate'

export const allLang: IAllLang = {
	...generalAllLang,
	...enumAllLang,
	...loginAllLang,
	...sideMenuAllLang,
	...affiliateAllLang,
	...offerAllLang,
	...offerScopeAllLang,
	...offerSpendAllLang,
	...postbackSendAllLang,
	...revenueAgencyAllLang,
	...revenueSpendAllLang,
	...accountAllLang,
	...roleAllLang
}